module.exports = __webpack_public_path__ + "static/media/m5.c4869645.jpg";